/* Dancing Disc — Home 2026 scroll reveal + media perf.
   Adds .in to .dd-reveal elements as they enter the viewport.
   Honors reduced-motion AND the theme editor (reveals everything immediately). */
(function () {
  var inEditor = window.Shopify && Shopify.designMode;

  function run() {
    var els = document.querySelectorAll('.dd-reveal');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // In the theme editor, reduced-motion, or without IO support: show everything now.
    if (inEditor || reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  // Play autoplay videos only while on screen — saves CPU/INP/battery on mobile
  // (the home stacks several autoplay grid videos + the hero).
  function videos() {
    var vids = document.querySelectorAll('video[autoplay]');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    // Reduced-motion: respeta la preferencia — pausa los autoplay (queda el póster).
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { vids.forEach(function (v) { try { v.pause(); } catch (e) {} }); return; }
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } }
        else if (!v.paused) { v.pause(); }
      });
    }, { threshold: 0.1 });
    vids.forEach(function (v) { vio.observe(v); });
  }

  // Lazy + viewport-gated playback for the reels marquee AND the video grid.
  // Both render <video preload="none"> with <source data-src> (reels:
  // .dd-reel__video; grid: .dd-vidcard__video). We inject src and play only when
  // the video nears the viewport (rootMargin), pause + tear down src when it
  // leaves — so the 24 marquee videos (12 reels × 2 passes) and the 3 grid
  // videos (~14MB) never download eagerly. No-JS shows the poster (no broken UI).
  function lazyVideos() {
    var reels = document.querySelectorAll('.dd-reel__video, .dd-vidcard__video');
    if (!reels.length || !('IntersectionObserver' in window)) return;
    // Reduced-motion: no cargamos ni reproducimos — queda el póster estático
    // (la marquesina ya está congelada por CSS). Respeta la preferencia y ahorra datos.
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    function tryPlay(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    function hydrate(v) {
      if (v.dataset.ddLoaded) return;
      var sources = v.querySelectorAll('source[data-src]');
      if (!sources.length) return;
      sources.forEach(function (so) { if (!so.getAttribute('src')) so.setAttribute('src', so.dataset.src); });
      v.dataset.ddLoaded = '1';
      // Safari/iOS: reproducir tras 'canplay' (no justo después de load(), que es async).
      v.addEventListener('canplay', function onCanPlay() { v.removeEventListener('canplay', onCanPlay); tryPlay(v); }, { once: true });
      v.load();
    }
    function teardown(v) {
      if (!v.dataset.ddLoaded) return;
      try { v.pause(); } catch (e) {}
      v.removeAttribute('src');
      v.querySelectorAll('source[src]').forEach(function (so) { so.removeAttribute('src'); });
      v.load();
      delete v.dataset.ddLoaded;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.dataset.ddLoaded) hydrate(v);  // primera vez: carga + play en 'canplay'
          else tryPlay(v);                       // re-entrada (ya cargado): play inmediato
        } else {
          if (!v.paused) { try { v.pause(); } catch (er) {} }
          if (e.intersectionRatio === 0) teardown(v);
        }
      });
    }, { root: null, rootMargin: '400px 200px', threshold: 0 });

    reels.forEach(function (v) { io.observe(v); });
  }

  // Community reels: hybrid drag over the infinite marquee.
  // The CSS marquee (translateX -50% keyframes) is great but captures no user
  // input — you can't drag to browse. Here we take over: JS drives the same
  // -50% loop via a --dd-x variable (rAF), and pointer drag pauses the auto
  // glide, moves the track by finger/mouse, then resumes from where it landed
  // (with a little inertia). Because the track is duplicated (2 passes), we wrap
  // --dd-x within [-half, 0] so the loop stays seamless. lazyVideos()'s
  // IntersectionObserver still sees each reel move, so lazy-load is untouched.
  function reelsDrag() {
    var sections = document.querySelectorAll('.dd-reels');
    if (!sections.length) return;
    // Reduced-motion / editor: leave the CSS behavior as-is (no JS takeover).
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || inEditor) return;

    sections.forEach(function (root) {
      var viewport = root.querySelector('.dd-reels__viewport');
      var track = root.querySelector('.dd-reels__track');
      if (!viewport || !track) return;

      // half = distance the CSS animation travels (-50% of the full track width).
      // Recomputed on resize because reel widths/gaps change at the 768px break.
      var half = 0;
      function measure() { half = track.scrollWidth / 2; }
      measure();

      // Match the CSS px/sec so the auto-glide feels identical. The CSS covers
      // `half` px over --dd-reel-dur (default 150s desktop / 200s mobile).
      var durVar = getComputedStyle(track).getPropertyValue('--dd-reel-dur').trim();
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
      var durMobileVar = getComputedStyle(track).getPropertyValue('--dd-reel-dur-mobile').trim();
      function parseSec(s) { var n = parseFloat(s); return /ms$/.test(s) ? n / 1000 : n; }
      var durSec = parseSec(isMobile ? (durMobileVar || durVar) : durVar) || 150;
      var speed = -half / durSec; // px per second, negative = leftward like the CSS

      var x = 0;            // current translate in px (0 → -half range)
      var dragging = false;
      var hovering = false; // desktop: pause auto-glide on hover (like the CSS did)
      var moved = false;    // crossed the click-vs-drag threshold this gesture?
      var startX = 0, startPointerX = 0, lastPointerX = 0, lastT = 0, velocity = 0;
      var pointerId = null;
      var rafId = null, prevTs = 0;

      // Keep x wrapped in [-half, 0] so the duplicated track loops seamlessly.
      function wrap(v) { if (half <= 0) return 0; while (v <= -half) v += half; while (v > 0) v -= half; return v; }
      function apply() { track.style.setProperty('--dd-x', x.toFixed(2) + 'px'); }

      function frame(ts) {
        if (!prevTs) prevTs = ts;
        var dt = (ts - prevTs) / 1000; prevTs = ts;
        if (!dragging && !hovering) {
          if (Math.abs(velocity) > Math.abs(speed) + 1) {
            // Coast on release inertia, easing back down to the base auto speed.
            x += velocity * dt;
            velocity *= 0.94;
            if (Math.abs(velocity) <= Math.abs(speed) + 1) velocity = 0;
          } else {
            x += speed * dt; // base auto glide
          }
          x = wrap(x);
          apply();
        }
        rafId = requestAnimationFrame(frame);
      }

      function onDown(e) {
        // Only left mouse button; let touch/pen through.
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true; moved = false;
        pointerId = e.pointerId;
        startX = x; startPointerX = e.clientX;
        lastPointerX = e.clientX; lastT = e.timeStamp; velocity = 0;
        viewport.classList.add('is-dragging');
        root.classList.add('is-dragging');
        try { viewport.setPointerCapture(pointerId); } catch (err) {}
      }
      function onMove(e) {
        if (!dragging || e.pointerId !== pointerId) return;
        var dx = e.clientX - startPointerX;
        if (!moved && Math.abs(dx) > 5) moved = true; // threshold: drag, not click
        if (moved) {
          x = wrap(startX + dx);
          apply();
          // Track instantaneous velocity for release inertia (px/sec).
          var dt = (e.timeStamp - lastT) / 1000;
          if (dt > 0) velocity = (e.clientX - lastPointerX) / dt;
          lastPointerX = e.clientX; lastT = e.timeStamp;
          // No preventDefault here: `touch-action: pan-y` (CSS) already hands the
          // horizontal axis to us while leaving vertical page scroll to the browser.
        }
      }
      function onUp(e) {
        if (!dragging || (pointerId !== null && e.pointerId !== pointerId)) return;
        dragging = false;
        viewport.classList.remove('is-dragging');
        // Keep .is-dragging on root one tick so the click that follows a drag is
        // swallowed (pointer-events:none on reels), then restore interactivity.
        if (moved) { setTimeout(function () { root.classList.remove('is-dragging'); }, 0); }
        else { root.classList.remove('is-dragging'); }
        try { viewport.releasePointerCapture(pointerId); } catch (err) {}
        pointerId = null;
        // Clamp fling velocity so a hard swipe doesn't rocket across the track.
        var max = 2600; if (velocity > max) velocity = max; if (velocity < -max) velocity = -max;
      }
      // A click that came from a real drag must not open the Instagram link etc.
      function onClickCapture(e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }

      // Desktop hover-pause (mouse only; touch has no meaningful hover).
      viewport.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hovering = true; });
      viewport.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hovering = false; });

      root.classList.add('dd-reels--js');
      viewport.addEventListener('pointerdown', onDown);
      viewport.addEventListener('pointermove', onMove, { passive: true });
      viewport.addEventListener('pointerup', onUp);
      viewport.addEventListener('pointercancel', onUp);
      viewport.addEventListener('click', onClickCapture, true);
      window.addEventListener('resize', measure);

      rafId = requestAnimationFrame(frame);
    });
  }

  // Home header (transparent→solid on scroll) is handled natively by Horizon
  // 4.1.0 (`data-sticky-state` + underlay). The frosted veil lives in
  // sections/header.liquid. No custom scroll listener needed here anymore.

  function init() { run(); videos(); lazyVideos(); reelsDrag(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor re-injects sections on edit (shopify:section:load) — re-reveal them
  // so a freshly edited section never sits invisible for the merchant.
  if (inEditor) {
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target || document;
      root.querySelectorAll('.dd-reveal').forEach(function (el) { el.classList.add('in'); });
      // Hidrata + reproduce los reels al instante en el editor para que el merchant los vea.
      root.querySelectorAll('.dd-reel__video').forEach(function (v) {
        v.querySelectorAll('source[data-src]').forEach(function (so) { if (!so.getAttribute('src')) so.setAttribute('src', so.dataset.src); });
        v.load(); var p = v.play(); if (p && p.catch) p.catch(function () {});
      });
    });
  }
})();
